const accordionTransitionTime = 600;

const styles = {
  accordionTransition: `height ${accordionTransitionTime}ms ease-in-out`,
  animationLong: 'fade-in-fwd-long 500ms cubic-bezier(0.39,0.575,0.565,1) 800ms both',
  animationShort: 'fade-in-fwd-short 300ms cubic-bezier(0.39,0.575,0.565,1) 500ms both',
  background: '#535151',
  bluePrimary: '#0077bd',
  blueSecondary: '#0077bd',
  boxShadow: 'rgba(0, 0, 0, 0.2)',
  selectedBoxShadow: 'rgba(0, 0, 0, 0.1)',
  breakLineColor: '#807D79',
  disabledMask: 'rgba(246,246,246,0.8)',
  disabledMaskLight: 'rgba(246,246,246,0.6)',
  disabledRow: 'rgba(217, 217, 217, 0.4)',
  disabledRowLight: 'rgba(217, 217, 217, 0.2)',
  errorColor: '#cc0b0a',
  failureScreenButtonGradient: 'linear-gradient(278deg, #ed373a, #ad1480)',
  fontMBank: '"mBank", Arial, sans-serif',
  fontMontserrat: 'Montserrat',
  footerColor: '#A6A6A6',
  footerColor2: '#979797',
  gray: '#656565',
  grayPrimary: ' #e6e6e6',
  graySecondary: '#E9E9E9',
  greenPrimary: '#16a035',
  greenSecondary: '#5cb130',
  gridSize: `${100 / 7}%`,
  gutterSize: '1.5rem',
  mainBg: '#F5F5F7',
  modalButton: '#9c9c9b',
  modalScrollbar: '#e3e3e5',
  opacityTransition: 'opacity 200ms ease-in-out',
  paymentColor: '#4a4a4a',
  paymentDescription: '#8e8e8e',
  primaryBlack: '#373432',
  primaryRed: '#e41e0a',
  primaryRedDarker: '#df1114',
  progressBarFill: '#626262',
  progressBarGradient: 'linear-gradient(135deg, #8fc21c, #16a035)',
  progressBarTransition: 'width 1s',
  progressPlaceholder: '#E9E9E9',
  progressPlaceholderDark: '#363534',
  secondaryBg: '#F1F1F2',
  secondaryBlack: '#201c17',
  secondaryRed: '#ff004e',
  statusBarColor: '#373432',
  textColorGray: '#AFAFAF',
  titleColor: '#454240',
  white: '#FFFFFF',
  whiteDarker: '#fbfbfb',
  tooltipBackground: '#f6f6f6',
  disableGray: '#000000',
  promoGradient: 'linear-gradient(to top,  #a31881, #5949a1)',
  promoMainColor: '#8D2A8D',
};

const fadeInAnimationLong = `@keyframes fade-in-fwd-long {
  0% {
    transform: scale(0.7) rotate(-10deg);
    opacity: 0;
  }
  100% {
    transform: scale(1) rotate(0);
    opacity: 1;
  }
}`;

const fadeInAnimationShort = `@keyframes fade-in-fwd-short {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`;

const progressAnimation = `@keyframes progress {
  0% {
    width: 100%;
  }
  50% {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  100% {
    width: 0%;
  }
}`;

const circleProgressAnimation = `
@keyframes circleProgressAnimation {
  0% {
    stroke-dashoffset: 326;
  }
  100% {
    stroke-dashoffset: 163;
  }
}`;

const PaymentCategoryType = {
  BLIK: 'BLIK',
  CARD: 'CARD',
  CARD_RECURRING: 'CARD_RECURRING',
  GOOGLE_PAY: 'GOOGLE_PAY',
  APPLE_PAY: 'APPLE_PAY',
  PBL: 'PBL',
  PAYPO: 'PAYPO',
  CLICK_TO_PAY: 'CLICK_TO_PAY',
};

const PaymentMethodStatus = {
  DISABLED: 'DISABLED',
  ENABLED: 'ENABLED',
};

const AuthorizationType = {
  CODE: 'CODE',
  REDIRECT: 'REDIRECT',
};

const DisableReason = {
  WRONG_AMOUNT: 'WRONG_AMOUNT',
  METHOD_DISABLED: 'METHOD_DISABLED',
  UNSUPPORTED: 'UNSUPPORTED',
};

const SavedInstrumentStatus = {
  ACTIVE: 'ACTIVE',
  EXPIRED_CARD: 'EXPIRED_CARD',
  EXPIRED_TOKEN: 'EXPIRED_TOKEN',
};

const BlikErrorCodes = {
  AUTHORIZATION_CODE_EXPIRED: 'AUTHORIZATION_CODE_EXPIRED',
  AUTHORIZATION_CODE_INVALID: 'AUTHORIZATION_CODE_INVALID',
  AUTHORIZATION_CODE_USED: 'AUTHORIZATION_CODE_USED',
};

const MobileHeights = {
  BASE: 108,
  BASE_CHECKED: 178,
  BOTTOM: -160,
  ITEM_HEIGHT: 80,
  MULTIPLICATOR: 160,
  TIMEOUT: 500,
  TOP: 0,
};

const mobileRegex = {
  // tslint:disable-next-line:ter-max-len
  mobile: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series([46])0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,
  // tslint:disable-next-line:ter-max-len
  tablet: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly([-_])|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c([- _agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac([ -/])|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|kgt([ /])|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([- ov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie([-m])|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel([im])|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c([- ])|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i,
};

const PaymentButtonValues = {
  SHOW: 75,
  LOADING: 52.5,
};

const availablePmpt = {
  PSP: 607,
  PSD2: 521,
  BM: 127,
  WORLDLINE: 1279,
  PAYPO: 2033,
};

const blikPlaceholder = '------';

const TOOLTIP_MOBILE_DURATION = 5000;

const languages = [
  {
    description: 'English',
    key: 'en',
  },
  {
    description: 'Polski',
    key: 'pl',
  },
  {
    description: 'Український',
    key: 'uk',
  },
];

const bmWidgetDefaultLocale = 'en';

export {
  accordionTransitionTime,
  AuthorizationType,
  DisableReason,
  blikPlaceholder,
  BlikErrorCodes,
  mobileRegex,
  styles,
  PaymentCategoryType,
  PaymentMethodStatus,
  MobileHeights,
  fadeInAnimationLong,
  fadeInAnimationShort,
  PaymentButtonValues,
  availablePmpt,
  progressAnimation,
  circleProgressAnimation,
  TOOLTIP_MOBILE_DURATION,
  languages,
  bmWidgetDefaultLocale,
  SavedInstrumentStatus,
};
